

































































import {Message} from 'element-ui';
import {Component, Vue} from 'vue-property-decorator';

@Component
export default class Information extends Vue {
  public iconDatas = [] as CreatedTags[];
  public pendingDatas = [] as CreatedTags[];
  public selfTagsList = [] as CreatedTags[];
  public tallyRecord = [] as RecordItem[];

  public beforeMount() {
    this.$store.commit('fetchTags');
    this.iconDatas = this.$store.state.iconDatas;
    this.pendingDatas = this.$store.state.pendingDatas;
    this.selfTagsList = this.$store.state.selfTagsList;
  }
  get sortIconDatas() {
    const array = this.iconDatas.sort((item1: CreatedTags, item2: CreatedTags) => {
      return item1.id - item2.id;
    });

    return array;
  }


  public addTag() {
    this.$router.replace('/createTag');
  }

  public removeTag(event: any) {
    this.$store.commit('fetchRecord');
    this.$store.commit('removeTag', event);

  }

  public recoverTag(event: any) {
    this.$store.commit('recoverTag', event);
  }


}
